@if (address) {
  <div class="row w-100 pt-5 text-center margin-auto">
    <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">Suppression adresse de livraison</div>
  </div>
}
@if (address) {
  <div class="col-12 w-100 text-center mt-5">
    <div class="bold-text text-danger mb-5">Etes-vous sûr de vouloir supprimer cette adresse de livraison?</div>
    <app-address-card [shippingAddress]="address" [label]="'Adresse de livraison'" [displayButton]="false"></app-address-card>
    <div class="cta_container mt-3">
      <button type="button" class="cta_cancel column" (click)="cancel()">Non<span></span></button>
      <button type="button" class="cta_btn level_2 column" (click)="delete()">Oui<span></span></button>
    </div>
  </div>
}